import Header from "../../Header";
import { useParams } from "react-router-dom";
import React, { useEffect, useState} from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { AxiosError } from 'axios';
import { AdminApi } from "../../../Api/AdminApi";
import { UserProject, ValidationErrors } from "../../../types/admin";
import UserProjectComponent from "../../../Components/admin/UserProjectComponent";
import { useAdmin } from "../../../Utils/AdminContext";

interface CreateUserProjectProps{
    projectId? : string|null,
    reloadUserProjects(): Promise<void>;
    userToExlude? : string[];
}
function CreateUserProject({
    projectId = null,
    reloadUserProjects,
    userToExlude = []
}:CreateUserProjectProps) {
  const { instance, accounts } = useMsal();
  const [ successMessage, setSuccessMessage ] = useState<string>("");
  const [ errorMessage, setErrorMessage ] = useState<string>("");
  const [errors, setErrors] = useState<ValidationErrors>({});
  const api = new AdminApi(accounts[0], instance);
  const navigate = useNavigate();

  
    const { isAdmin, setIsAdmin } = useAdmin();
    useEffect(() => {
      if (isAdmin === false) {
        navigate('/'); 
      }
    }, [isAdmin, navigate]);
  const [ userProject, setUserProject] = useState<UserProject>({
        userId: "",
        projectId : projectId? projectId :"" ,
        role: 0
    });

    const handleInputChange = (field: keyof UserProject) => (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        console.log(field, e.target.value);
        
        setUserProject(prev => ({
            ...prev,
            [field]: e.target.value
        }));
    };

  const handleSubmit = async () => {
    setErrors({});
    setSuccessMessage("");
    setErrorMessage("");
    try{
        console.log(userProject)
      var result = await api.createUserProject(userProject);
      if (result === "success") {
        setSuccessMessage("UserProject has been successfully created");
      }
      console.log('reload')
      await reloadUserProjects();
      return true; // Return true on success

    }catch(error)
    {
      if (error instanceof AxiosError && error.response?.status === 400) {
        setErrors(error.response.data.errors);
        setErrorMessage("Failed to add user to project. Please check your inputs and try again.");
      }else{
        navigate("/")
      }
      return false; // Return false on error
    }
  }
  return (
    <>
        <div className="project-container">
           <UserProjectComponent 
                  onChange={handleInputChange}
                  handleSubmit={handleSubmit}
                  userProject={userProject}
                  errors={errors}
                  successMessage={successMessage}
                  errorMessage={errorMessage}
                  projectId={projectId}
                  userToExclude={userToExlude}/>
        </div>
    </>
  );
}

export default CreateUserProject;